import { Link } from 'react-router-dom';

import { theme } from '@notino/react-styleguide';

import Dropdown from '@components/Dropdown';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Items = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const Item = styled(Link)<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  cursor: pointer;
  flex: 1;
  text-decoration: none;
  ${theme.typography.labelRegular}

  color: ${({ isSelected }) =>
    isSelected ? theme.color.text.primary : theme.color.text.secondary};

  border: solid
    ${({ isSelected }) =>
      isSelected
        ? `2px ${theme.color.border.selected}`
        : `1px ${theme.color.border.default}`};
`;

export const StyledDropdown = styled(Dropdown)`
  [data-id='selected-value'] {
    border: 2px solid ${theme.color.border.selected};
    padding: 1rem;
  }
`;

export const SelectValue = styled.div`
  flex: 1;
  color: ${theme.color.text.secondary};
  ${theme.typography.labelRegular}
`;

export const SelectOption = styled(Link)`
  padding: 1rem;
  display: block;

  color: ${theme.color.text.secondary};

  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

export const VariantLabelText = styled.div`
  color: ${theme.color.common.gray30};
  ${theme.typography.labelRegular400}
  margin-bottom: 0.5rem;
  margin-top: 0.25rem;
`;
